import { type UseQueryResult } from '@tanstack/react-query';

import { useApiQuery } from '../../../lib/api/hooks.js';
import { roomTypes, roomTypeAmenitiesEndpoints } from './endpoints.js';
import {
  roomTypeAmenitiesResponse,
  type RoomTypeAmenitiesResponse,
  type RoomTypeDetail,
} from './schemas.js';

/**
 * Reads for the Room Types module.
 *
 * The list is owned by `ResourceListPage`; the detail and reference data live
 * here. Property options are reused from the Properties module, because a room
 * type is always scoped to one property.
 */

export function useRoomType(roomTypeId: string): UseQueryResult<RoomTypeDetail> {
  return roomTypes.useItem(roomTypeId);
}

export function useRoomTypeAmenities(
  roomTypeId: string,
): UseQueryResult<RoomTypeAmenitiesResponse> {
  return useApiQuery({
    queryKey: ['room-type-amenities', roomTypeId],
    path: roomTypeAmenitiesEndpoints.get(roomTypeId),
    schema: roomTypeAmenitiesResponse,
    enabled: roomTypeId !== '',
  });
}
